export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50">
                17吃瓜网
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              <strong>17吃瓜网</strong>——国内领先的<strong>吃瓜在线</strong>内容平台。每日更新<strong>最新黑料</strong>与<strong>吃瓜资源</strong>，为百万瓜友提供<strong>吃瓜网站</strong>首页入口与<strong>吃瓜APP</strong>下载服务。<strong>17一起吃瓜网</strong>，让吃瓜成为日常。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</a>
              <a href="#updates" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">最新快讯</a>
              <a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">精彩视频</a>
              <a href="#app" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">APP下载</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">吃瓜分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">明星八卦</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">网红翻车</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">综艺内幕</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">直播塌房</span>
              <span className="text-sm text-foreground-300 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">海外爆料</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              诚邀优质内容平台与媒体伙伴合作共建。合作洽谈请通过投稿邮箱联系。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-400">
          <p>&copy; 2020-2024 17吃瓜网 All Rights Reserved.</p>
          <div className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}